(() => {
  const API = 'https://mini-pc-zippo.taile4178b.ts.net:8443/candidature/api';
  const MAX_FILE = 10 * 1024 * 1024;
  document.querySelectorAll('[data-careers]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const copy = JSON.parse(root.querySelector('[data-careers-copy]').textContent);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), {
        threshold: .03
      });
      root.querySelectorAll('[data-careers-reveal]').forEach(e => {
        e.classList.add('careers__pending');
        observer.observe(e);
      });
    }
    const success = root.querySelector('[data-careers-success]');
    const form = root.querySelector('form');
    if (!form) return;
    const field = name => form.querySelector(`[data-field="${name}"]`);
    const status = form.querySelector('[data-status]');
    const submit = form.querySelector('[data-submit]');
    const removeFile = form.querySelector('[data-remove-file]');
    let busy = false,
      challengePromise = null,
      key = crypto.randomUUID();
    function message(text, error = false) {
      status.textContent = text;
      status.dataset.error = String(error);
    }
    async function json(url, options = {}, timeout = 15000) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), timeout);
      try {
        const response = await fetch(url, {
          ...options,
          signal: controller.signal,
          credentials: 'omit'
        });
        const data = await response.json();
        if (!response.ok) {
          const error = new Error(data.error || copy.failed);
          error.field = data.field;
          error.status = response.status;
          throw error;
        }
        return data;
      } finally {
        clearTimeout(timer);
      }
    }
    function getChallenge() {
      if (!challengePromise) challengePromise = json(API + '/challenge').then(data => data.challenge).catch(error => {
        challengePromise = null;
        throw error;
      });
      return challengePromise;
    }
    getChallenge().catch(() => {});
    function validateGroups() {
      form.querySelectorAll('[data-group]').forEach(group => {
        if (!['areas', 'relations'].includes(group.dataset.group)) return;
        const first = group.querySelector('input');
        first.setCustomValidity(group.querySelector('input:checked') ? '' : copy.required);
      });
    }
    function validateFile() {
      const file = field('resume').files[0];
      let error = '';
      if (file) {
        if (file.size > MAX_FILE) error = copy.fileSize;else if (!/\.(pdf|jpe?g|png)$/i.test(file.name)) error = copy.fileType;
      }
      field('resume').setCustomValidity(error);
      root.querySelector('[data-file-name]').textContent = file ? file.name : copy.noFile;
      removeFile.hidden = !file;
      return error;
    }
    removeFile.addEventListener('click', () => {
      field('resume').value = '';
      validateFile();
      field('resume').focus();
    });
    root.querySelector('a[href="#CareerPrivacy"]').addEventListener('click', () => {
      root.querySelector('#CareerPrivacy').open = true;
    });
    form.addEventListener('change', () => {
      validateGroups();
      validateFile();
    });
    form.addEventListener('input', e => e.target.removeAttribute('aria-invalid'));
    submit.addEventListener('click', () => {
      validateGroups();
      validateFile();
    });
    function readFile(file) {
      if (!file) return Promise.resolve(null);
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve({
          name: file.name,
          data: reader.result.split(',')[1]
        });
        reader.onerror = () => reject(new Error(copy.failed));
        reader.readAsDataURL(file);
      });
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      validateGroups();
      validateFile();
      if (!form.reportValidity()) return;
      busy = true;
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      message(copy.sending);
      const controls = [...form.elements].filter(e => !e.disabled && e.type !== 'hidden' && e !== submit);
      try {
        const payload = {
          key,
          challenge: await getChallenge(),
          language: root.dataset.language.startsWith('en') ? 'en' : 'it'
        };
        for (const name of ['first_name', 'last_name', 'email', 'phone', 'city', 'presentation', 'website']) payload[name] = field(name).value;
        payload.privacy = field('privacy').checked;
        payload.future = field('future').checked;
        form.querySelectorAll('[data-group]').forEach(group => {
          payload[group.dataset.group] = [...group.querySelectorAll('input:checked')].map(e => e.value);
        });
        controls.forEach(e => e.disabled = true);
        payload.resume = await readFile(field('resume').files[0]);
        let data;
        try {
          data = await json(API + '/applications', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }, 90000);
        } catch (error) {
          if (error.status !== 403) throw error;
          challengePromise = null;
          payload.challenge = await getChallenge();
          await new Promise(resolve => setTimeout(resolve, 1100));
          data = await json(API + '/applications', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }, 90000);
        }
        if (data.received !== true || !/^CAND-[A-F0-9]{16}$/.test(data.reference)) throw new Error(copy.failed);
        root.querySelector('[data-careers-reference]').textContent = `${copy.reference}: ${data.reference}`;
        root.querySelector('[data-careers-fields]').hidden = true;
        form.removeAttribute('aria-busy');
        success.hidden = false;
        success.focus();
      } catch (error) {
        controls.forEach(e => {
          e.disabled = false;
        });
        submit.disabled = false;
        form.removeAttribute('aria-busy');
        busy = false;
        const target = error.field && (field(error.field) || form.querySelector(`[data-group="${error.field}"] input`));
        if (target) {
          target.setAttribute('aria-invalid', 'true');
          target.focus();
        }
        message(root.dataset.language.startsWith('en') ? copy.failed : error.status && error.message ? error.message : copy.failed, true);
      }
    }, { capture: true });
    submit.disabled = false;
  });
})();
